// extracted by mini-css-extract-plugin
export default {"container":"RejectNomination_container__GtHer","title":"RejectNomination_title__cUdfs","consent":"RejectNomination_consent__kR3ih"};